import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import { useTransition360Access } from '@/hooks/useTransition360Access';

function Transition360Gate() {
    // isPending, not isLoading: the query is idle without data while the persisted cache restores.
    const { canAccess, isPending, isFetching } = useTransition360Access();

    if (isPending) {
        return null;
    }

    if (!canAccess) {
        // A restored list can be stale, so only send the user home once the refetch settles.
        return isFetching ? null : <Navigate to="/" />;
    }

    return (
        <div className="flex h-full min-h-0 flex-col">
            <Outlet />
        </div>
    );
}

export const Route = createFileRoute('/transition-360')({
    component: Transition360Gate,
});
